import { render, staticRenderFns } from "./SegmentPublishAssistant.vue?vue&type=template&id=24b7acde&scoped=true"
import script from "./SegmentPublishAssistant.vue?vue&type=script&lang=js"
export * from "./SegmentPublishAssistant.vue?vue&type=script&lang=js"
import style0 from "./SegmentPublishAssistant.vue?vue&type=style&index=0&id=24b7acde&prod&scoped=true&lang=css"
import style1 from "./SegmentPublishAssistant.vue?vue&type=style&index=1&id=24b7acde&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b7acde",
  null
  
)

export default component.exports